import React, { useContext, useEffect, useState } from 'react'
import { PolicyModification } from '../PolicyModification/PolicyModification'
import { ModificationSummary } from '../PolicyModification/ModificationSummary'
import { PolicyModificationContextStore } from '../../../context/PolicyModificationContext'

export const PolicyModificationSection = () => {
  const modifyContext = useContext(PolicyModificationContextStore)
  const [isInModifyFlow, setIsInModifyFlow] = useState(true)

  useEffect(() => {
    setIsInModifyFlow(!modifyContext.is_modify_finish)
  }, [modifyContext.is_modify_finish])

  return isInModifyFlow ? <PolicyModification /> : <ModificationSummary />
}
